import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Sponsor: An entity, such as a federal agency or foundation, that provides funding, by an award, for research projects.',
    name: 'Sponsors',
    partialId: PartialId.Standard.create('sponsors'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
